import React, { useEffect, useState } from "react";
import { compose } from "redux";

import withAddAlert from "../../../../../hocs/withAddAlert";
import withTranslations from "../../../../../hocs/withTranslations";
import useWebNetworkStatus, {
  NetworkStatus
} from "../../../../../hooks/useWebNetworkStatus";

const NetworkStatusProvider = ({
  translate,
  addWarningAlert,
  addSuccessAlert
}) => {
  const [isMounted, setIsMounted] = useState(false);

  const { networkStatus } = useWebNetworkStatus({
    defaultNetworkStatus: NetworkStatus.ONLINE
  });

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);
      return;
    }

    if (networkStatus === NetworkStatus.OFFLINE) {
      addWarningAlert({
        title: "offline_alert_title"
      });
    } else if (networkStatus === NetworkStatus.ONLINE) {
      addSuccessAlert({
        title: "online_alert_title"
      });
    }
  }, [networkStatus]);

  return networkStatus === NetworkStatus.OFFLINE ? (
    <div className="content-section">
      <h1 className="big-heading questions-list-heading">
        {translate("offline_header")}
      </h1>
      <p>{translate("offline_description")}</p>
    </div>
  ) : null;
};

export default compose(withAddAlert, withTranslations)(NetworkStatusProvider);
